export default function (Component) {
      Component.options.__docs = "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n```jsx\n<mks-site-footer>Made by makesense</mks-site-footer>\n```\n\n\n"
    }